import React, { useState } from 'react';
import { Button } from '../components/Button';
import { Stepper } from '../components/Stepper';
interface ScanPageProps {
  showFrame: (screen: string) => void;
}
export const ScanPage: React.FC<ScanPageProps> = ({
  showFrame
}) => {
  const [showNext, setShowNext] = useState(false);
  const [plots, setPlots] = useState<React.ReactNode[]>([]);
  // Actual Nyquist plot image
  const nyquistPlotUrl = 'https://uploadthingy.s3.us-west-1.amazonaws.com/ag9xoTsdzmpd7CDMoRRfDn/nyquist.png';
  const steps = ['Baseline', 'Sampling', 'Transfer', 'Scan', 'Results'];
  const startScan = () => {
    const newPlots = [];
    for (let i = 0; i < 32; i++) {
      newPlots.push(<div key={i} className="bg-white rounded-lg shadow p-3 flex flex-col items-center" data-id="element-92">
          <img src={nyquistPlotUrl} alt="Nyquist Plot" className="w-24 h-24 object-contain" data-id="element-93" />
          <p className="text-blue-600 text-xs mt-2 font-medium" data-id="element-94">BS {i + 1}</p>
        </div>);
    }
    setPlots(newPlots);
    setShowNext(true);
  };
  return <div className="container mx-auto px-4 py-8 max-w-6xl" data-id="element-95">
      <Stepper currentStep={3} steps={steps} data-id="element-96" />
      <div className="text-center mb-8" data-id="element-97">
        <h2 className="text-3xl font-bold text-blue-600 mb-4" data-id="element-98">
          Pathogen EIS Scan
        </h2>
        <p className="text-gray-600" data-id="element-99">Perform EIS scan on pathogen solution.</p>
      </div>
      <div className="flex justify-center mb-8" data-id="element-100">
        <Button text="Start Pathogen Scan" icon="⚡" onClick={startScan} size="lg" data-id="element-101" />
      </div>
      {plots.length > 0 && <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-3 mb-8" data-id="element-102">
          {plots}
        </div>}
      <div className="flex justify-center space-x-4" data-id="element-103">
        {showNext && <Button text="View Results" icon="📊" onClick={() => showFrame('results')} data-id="element-104" />}
        <Button text="Back" icon="⬅" variant="secondary" onClick={() => showFrame('transfer')} data-id="element-105" />
      </div>
    </div>;
};